import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b484f08d51a300143345a3/quantume_nautilus/src/app/report-generator/page.tsx");
